import DoneIcon from '@mui/icons-material/Done';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutlined';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Divider, Paper, Typography } from '@mui/material';

interface PasswordRulesDisplayProps {
  constraints: { constraint: string; valid: boolean }[];
  fieldsAreDirty?: boolean;
  title?: string;
  warning?: string;
}

const iconSx = { width: 15, height: '1.25rem', marginRight: 1, flexShrink: 0 };

const PasswordRulesDisplay = ({
  constraints,
  fieldsAreDirty,
  title = 'Please ensure your password meets the following requirements:',
  warning,
}: PasswordRulesDisplayProps) => {
  return (
    <Paper
      sx={{
        padding: 1,
        backgroundColor: 'inherit',
        height: 'fit-content',
        justifyContent: 'center',
      }}
      variant="outlined"
    >
      <Typography
        align="center"
        variant="body2"
        sx={{ display: 'flex', alignItems: 'center' }}
      >
        {title}
      </Typography>
      <Divider sx={{ marginY: 1 }} />
      {constraints.map(({ constraint, valid }) => {
        const color = !fieldsAreDirty
          ? ''
          : `${valid ? 'success' : 'error'}.main`;
        const Icon = !fieldsAreDirty
          ? KeyboardArrowRightIcon
          : valid
            ? DoneIcon
            : ErrorOutlineIcon;
        return (
          <Typography
            key={constraint}
            variant="caption"
            color={color}
            sx={{ display: 'flex', alignItems: 'flex-start' }}
          >
            <Icon sx={iconSx} />
            {constraint}
          </Typography>
        );
      })}
      {warning && (
        <Typography
          variant="caption"
          color="warning.main"
          sx={{ display: 'flex', alignItems: 'flex-start' }}
        >
          <WarningAmberIcon sx={iconSx} />
          Warning: {warning}
        </Typography>
      )}
    </Paper>
  );
};

export default PasswordRulesDisplay;
